import { isDeviceScheduleActive } from '../sync/device-schedule.js';

/** @typedef {'outside_schedule' | 'empty_playlist' | 'no_slots_active' | null} InactiveReason */

/** @type {InactiveReason} */
let inactiveReason = null;

/** @param {InactiveReason} reason */
export function setInactiveReason(reason) {
  inactiveReason = reason;
}

export function clearInactiveReason() {
  inactiveReason = null;
}

/** @returns {InactiveReason} */
export function getInactiveReason() {
  return inactiveReason;
}

/**
 * @param {object | null | undefined} program
 * @param {Date} [ref]
 * @param {{ trustApiActive?: boolean }} [opts]
 *   `trustApiActive` (default `true`) — for fresh API responses, honor `program.active` /
 *   `program.inactiveReason`. Pass `false` when evaluating a cached manifest (offline /
 *   refresh / boot guard): the cached flag may be stale (e.g. saved outside plant hours),
 *   so we re-evaluate locally from `deviceSchedule` + slots only.
 * @returns {{ shouldPlay: boolean; inactiveReason: InactiveReason }}
 */
export function evaluatePlaybackFromManifest(program, ref = new Date(), opts = {}) {
  const trustApiActive = opts.trustApiActive !== false;
  if (!program) return { shouldPlay: false, inactiveReason: null };

  if (!Array.isArray(program.slots) || program.slots.length === 0) {
    return {
      shouldPlay: false,
      inactiveReason: trustApiActive
        ? (program.inactiveReason ?? 'empty_playlist')
        : 'empty_playlist',
    };
  }

  if (program.deviceSchedule && !isDeviceScheduleActive(program.deviceSchedule, ref)) {
    return { shouldPlay: false, inactiveReason: 'outside_schedule' };
  }

  if (trustApiActive && program.active === false) {
    return {
      shouldPlay: false,
      inactiveReason: program.inactiveReason ?? 'outside_schedule',
    };
  }

  return { shouldPlay: true, inactiveReason: null };
}

/**
 * @param {object | null | undefined} program
 * @param {{ trustApiActive?: boolean }} [opts]
 */
export function shouldRotate(program, opts) {
  return evaluatePlaybackFromManifest(program, undefined, opts).shouldPlay;
}
